export const ReceiptBill = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 8H15M9 12H11M19 21V4C19 3.44772 18.5523 3 18 3H6C5.44772 3 5 3.44772 5 4V21L7.33333 19L9.66667 21L12 19L14.3333 21L16.6667 19L19 21Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ReceiptBill
